export default "__VITE_ASSET__490b72de__"